import React from 'react';
import PropTypes from 'prop-types';

import { getStaticText } from '../../../utils/constants';
import Down from '../assets/Down.svg';
import Pdf from '../assets/Pdf.svg';
import Xlsx from '../assets/Xlxs.svg';

function DownloadMenu({ lang, dwnldDrop, showDwnldDrop, onPpt, onExcel }) {
    const { SITE_TEXT } = getStaticText(lang);
    const { DOWNLOAD, DOWNLOAD_PPT, DOWNLOAD_EXCEL } = SITE_TEXT;

    const handlePpt = event => {
        event.stopPropagation();
        showDwnldDrop(false);
        onPpt();
    };

    const handleExcel = event => {
        event.stopPropagation();
        showDwnldDrop(false);
        onExcel();
    };

    return (
        <li data-testid="getPptBtn" onClick={() => showDwnldDrop(!dwnldDrop)} className="resurveyImg dwnld">
            <img src={Down} alt="" />
            <span className="lineHead upperHead">{DOWNLOAD}</span>
            {dwnldDrop && (
                <div className="tabsContent" onMouseLeave={() => showDwnldDrop(false)}>
                    <span data-testid="iePptBtn" onClick={handlePpt}>
                        <span>
                            <img src={Pdf} alt="" />
                        </span>
                        {DOWNLOAD_PPT}
                    </span>
                    <span data-testid="ieExcelBtn" onClick={handleExcel}>
                        <span>
                            <img src={Xlsx} alt="" />
                        </span>
                        {DOWNLOAD_EXCEL}
                    </span>
                </div>
            )}
        </li>
    );
}

DownloadMenu.propTypes = {
    lang: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    dwnldDrop: PropTypes.bool.isRequired,
    showDwnldDrop: PropTypes.func.isRequired,
    onPpt: PropTypes.func.isRequired,
    onExcel: PropTypes.func.isRequired,
};

DownloadMenu.defaultProps = {
    lang: '1033',
};

export default DownloadMenu;
